import { processGeojson } from 'kepler.gl/processors';
import { wrapTo, removeDataset } from 'kepler.gl/actions';
import { addDataToMap } from "kepler.gl/actions";

const SEGMENT_HEATMAP_SCORE_GEO_JSON_PATH = "/final_segments_with_scores_centroid.geojson";

export const fetchAndProcessSegmentHeatmapScoreGeoJSON = async (setLayerDataState, dispatch, store) => {
    let geojson;
    try {
        const response = await fetch(SEGMENT_HEATMAP_SCORE_GEO_JSON_PATH);
        if (!response.ok) {
            console.error('Invalid Segment Heatmap Score GeoJSON data', response.statusText);
        }

        // Parse the JSON data
        geojson = await response.json();
        if (!geojson || !geojson.features) {
            console.error('Invalid Segment Heatmap Score GeoJSON data');
        }

        console.log("Segment Heatmap Score GeoJSON", geojson);
    } catch(error) {
        console.error('Error fetching zone GeoJSON data:', error);
    }

    setLayerDataState((prev) => ({ ...prev, segmentHeatmapScoreGeoJSON: geojson }));

    console.log("Sujeet Segment Heatmap Score ProcessedGeoJson : ", processGeojson(geojson));

    dispatch(wrapTo('evidence', removeDataset('segmentheatmapscore')));

    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "SegmentHeatmapScore", id: "segmentheatmapscore" },
                    data: processGeojson(geojson)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
                visState: {
                    interactionConfig: {
                        geocoder: {
                            enabled: true
                        }
                    },
                    layers: [
                        {
                            "id": "segmentheatmapscore",
                            "type": "heatmap",
                            "config": {
                                "dataId": "segmentheatmapscore",
                                "columnMode": "points",
                                "label": "BLR Road Segment Heatmap Score",
                                "color": [
                                    248,
                                    149,
                                    112
                                ],
                                "highlightColor": [
                                    252,
                                    242,
                                    26,
                                    255
                                ],
                                "columns": {
                                    "lat": "latitude",
                                    "lng": "longitude",
                                    "Tree Score": "Tree Score",
                                    "Cleanliness Score": "Cleanliness Score",
                                    "Infra Score": "Infra Score",
                                    "Nuisance Score": "Nuisance Score"
                                },
                                "isVisible": false,
                                "visConfig": {
                                    "opacity": 0.56,
                                    "strokeOpacity": 0.8,
                                    "thickness": 2,
                                    "strokeColor": [
                                        47,
                                        197,
                                        204
                                    ],
                                    "colorRange": {
                                        "colors": [
                                            "#A50026",
                                            "#64BC61",
                                            "#006837"
                                        ],
                                        "name": "color.customPalette",
                                        "type": "custom",
                                        "category": "Custom"
                                    },
                                    "strokeColorRange": {
                                        "name": "Global Warming",
                                        "type": "sequential",
                                        "category": "Uber",
                                        "colors": [
                                        "#4C0035",
                                        "#880030",
                                        "#B72F15",
                                        "#D6610A",
                                        "#EF9100",
                                        "#FFC300"
                                        ]
                                    },
                                    "radius": 19,
                                    "sizeRange": [
                                        0,
                                        10
                                    ],
                                    "radiusRange": [
                                        0,
                                        50
                                    ],
                                    "heightRange": [
                                        0,
                                        500
                                    ],
                                    "elevationScale": 5,
                                    "stroked": true,
                                    "filled": false,
                                    "enable3d": false,
                                    "wireframe": false,
                                    "fixedHeight": false
                                },
                                "hidden": false,
                                "textLabel": [
                                    {
                                        "field": null,
                                        "color": [
                                        255,
                                        255,
                                        255
                                        ],
                                        "size": 18,
                                        "offset": [
                                        0,
                                        0
                                        ],
                                        "anchor": "start",
                                        "alignment": "center",
                                        "outlineWidth": 0,
                                        "outlineColor": [
                                        255,
                                        0,
                                        0,
                                        255
                                        ],
                                        "background": false,
                                        "backgroundColor": [
                                        0,
                                        0,
                                        200,
                                        255
                                        ]
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        })
    );

    console.log("Current Map Segment Heatmap Score Configuration:", store.getState());

    console.log("Sujeet Segment Heatmap Score useEffect end", geojson);
};